import React, { useContext, useEffect, useState } from "react";
import Sidebar from "../components/sidebar";
import Dashnavbar from "../components/dashnavbar";
import { Outlet, useNavigate } from "react-router-dom";
import { isLoggedIn } from "../utils/utils";
import { MyContext } from "../MyContext/MyProvider";

const Dashboard = () => {
  const { reductionType, setReductionType } = useContext(MyContext);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {

      setReductionType("highlight")

  }, []);
  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };
  return (
    <>
      <div className="Dashboard-main-container d-flex overflow-x-hidden">
        <div className="left-content">
          <Sidebar isDrawerOpen={isDrawerOpen} toggleDrawer={toggleDrawer} />
        </div>
        <div className="right_content  md:p-0 w-full md:w-[87%] ">
          <Dashnavbar toggleDrawer={toggleDrawer} />
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
